import { ApiAttribute, EndpointAttributes } from '@context/openapi/types';

export const isAnyEndpointAttributeFilled = (
  endpointAttributes: EndpointAttributes
): boolean => {
  const endpointAttrs = endpointAttributes.params;

  const allAttributes = endpointAttrs.concat(
    endpointAttributes.pathParameters,
    endpointAttributes.queryParams
  );

  return allAttributes.some((attribute) => isFieldFilled(attribute));
};

export const isFieldFilled = (attribute: ApiAttribute): boolean => {
  if (attribute.type === 'OBJECT') {
    return attribute.child.some((child) => child.value || child.filter);
  }

  if (attribute.type === 'ARRAY') {
    return attribute.child.some((child) => child.value || child.filter);
  }

  if (attribute.value || attribute.filter) return true;

  return false;
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    // Fallback for older browsers or when clipboard API is not available
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      textArea.remove();
      return true;
    } catch {
      textArea.remove();
      return false;
    }
  } catch {
    return false;
  }
};

export const isFieldVisibilityOverridden = (
  attribute: ApiAttribute,
  visibleFieldsOverride: string[]
): boolean => {
  return Array.isArray(visibleFieldsOverride)
    ? visibleFieldsOverride.includes(attribute.key)
    : false;
};

export const getFormattedDate = () => {
  const now = new Date();
  return `${String(now.getDate()).padStart(2, '0')}_${String(now.getMonth() + 1).padStart(2, '0')}_${now.getFullYear()}_${String(now.getHours()).padStart(2, '0')}_${String(now.getMinutes()).padStart(2, '0')}_${String(now.getSeconds()).padStart(2, '0')}`;
};
